/*=========================================================================================
  File Name: gameActions.js
  Description: game Module Actions
==========================================================================================*/

import Vue from 'vue';
import axios from 'axios';
import router from '../../routes/router';
import store from '../vuex';
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';
import CryptoJS from 'crypto-js';

/**
 * Decrypt Game Data
 *
 *
 */
const decrpytGameData = (data) => {
  const bytes = CryptoJS.AES.decrypt(
    data,
    "^gqvYY@%'=37r7B"
    //process.env.VUE_APP_GAME_DATA_SECRET
  );

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export default {
  // update api
  /**
   * Init Action, Validate Token and return game object
   *
   */
  async init({ commit, dispatch }, obj) {
    try {
        'call init'
      const gameObj = await axios
        .post(`https://gm.defensilx918.com/api/init/${obj.token}`)
        .then((res) => res.data)
        .catch((err) => err);

        if (gameObj.username) {
          commit('SET_MEMBER', {
            username: gameObj.username,
            balance: parseInt(gameObj.balance),
            currency: gameObj.currency,
            prevBalance:null,
            prevRoom:null,
          });

          if ((gameObj.settings).length > 0) {

            for(const setting of gameObj.settings) {
              commit('SET_' + setting.code, setting.value)
            }
          }

          commit('SET_GAME', {
            code: gameObj.rooms[0].game,
            lang: gameObj.lang,
            rooms: gameObj.rooms.map((v) => ({ ...v, timer: 0 })),
          });

          commit('SET_LEVELS', gameObj.levels);

          this._vm.$cookies.set('game_session', obj.token, '15m');
          this._vm.$cookies.set('game_name', gameObj.rooms[0].game);

          if (localStorage.getItem('isMobile') == "true") {
            
            if(obj.table_id) router.replace(`/m/game/${gameObj.rooms[0].game}/${String(obj.table_id).toUpperCase()}`).catch();
            else router.replace('/m/lobby').catch();
            
          } else {
            if(obj.table_id) router.replace(`/game/${gameObj.rooms[0].game}/${String(obj.table_id).toUpperCase()}`).catch();
            else router.replace('/lobby').catch();
          }

          await dispatch('initWebsocket', {
            game: gameObj.rooms[0].game,
            socket: gameObj.socket_url,
            table_id: obj.table_id,
          });

          localStorage.setItem('bgmPlaying', false);
        } else {
          router.push('/session-expired');
        }
    } catch(e) {
      console.log(e)
    }
  },
  /**
   * Check if game session cookie is present
   *
   */
  async checkIfLoggedIn({ state }) {
    const token = this._vm.$cookies.get('game_session');
    const game = this._vm.$cookies.get('game_name');

    try {
      if (!token) router.push('/session-expired');

      if (
        !state.game.code ||
        !state.member.username ||
        state.levels.length == 0
      ) {
        router.replace({
          path: '/launch/h',
          query: { game: game, token: token },
        }).catch()
      }
    } catch (e) {
      //console.log(e)
      router.push('/session-expired');
    }
  },
  /**
   * Force Logout
   */
  forceLogout() {
    router.push('/session-expired'); 
  },
  /**
   * Init Websocket
   *
   */
async initWebsocket({ commit }, param) {
    const token = this._vm.$cookies.get('game_session');

    if (!token) router.push('/session-expired');
    const socket = io(param.socket, { query: { token } });

    Vue.use(VueSocketIOExt, socket, { store });

    //socket.on('init', (data) => {});

    socket.on('current_room', (data) => {
      const decoded = decrpytGameData(data);
      commit('SET_ROOM_DATA', decoded);
      
      if (decoded.state === 1 && decoded.initial) socket.emit('balance');
      if (decoded.state === 0) socket.emit('balance');

      if (decoded.video) commit('SET_VIDEO', decoded.video);

      // console.log(decoded)
    });

    socket.on('lobby', (data) => {
      commit('SET_LOBBY_ROOM_DATA', decrpytGameData(data));

      //console.log(decrpytGameData(data))
    });

    socket.on('bet_chips', (data) => {
      commit('SET_BET_CHIPS', data);
    });

    socket.on('video', (data) => {
      commit('SET_VIDEO', data);
    });

    socket.on('bet_success', () => {
      const messageCode = 'bettingSuccessful';

      commit('betModule/BET_NOTIFY', messageCode, { root: true });
      setTimeout(() => {
        commit('betModule/BET_NOTIFY_CLEAR', null, { root: true });
      }, 1000);
    });

    socket.on('current_bettings', (data) => {
      commit('betModule/SET_INIT_BET', data, { root: true });
    });

    socket.on('bet_fail', (data) => {
      commit('betModule/ROLLBACK_BETTING', null, { root: true });
      commit('betModule/BET_NOTIFY', data.message, { root: true });
      setTimeout(() => {
        commit('betModule/BET_NOTIFY_CLEAR', null, { root: true });
      }, 1000);
    });

    socket.on('bet_cancel_resp', (data) => {
      if (data.message == 'BET_CANCEL_SUCCESS') {
        commit('betModule/CLEAR_BETTING', null, { root: true });
        this._vm.$socket.client.emit('balance');
      }

      commit('betModule/BET_NOTIFY', data.message, { root: true });
      setTimeout(() => {
        commit('betModule/BET_NOTIFY_CLEAR', null, { root: true });
      }, 1000);
    });

    socket.on('balance', (data) => {
      commit('SET_BALANCE', data.balance);
    });

    socket.on('bet_cancel_fail', () => {
      const messageCode = 'bettingCancelFail';

      commit('betModule/BET_NOTIFY', messageCode, { root: true });
      setTimeout(() => {
        commit('betModule/BET_NOTIFY_CLEAR', null, { root: true });
      }, 1000);
    });

    socket.on('error', data => {

      if(data.message === 'AGENT_API_CALL_FAILED') {
        commit('betModule/ROLLBACK_BETTING', null, { root: true });
        commit('betModule/BET_NOTIFY', data.message, { root: true });
        setTimeout(() => {
          commit('betModule/BET_NOTIFY_CLEAR', null, { root: true });
        }, 1000);
      }
    })

    socket.on('disconnected', function() {
      //router.push('/session-expired');
    });
    
  },
};
